export default "/images/4dd258e72721d7f2f5c17e753f87340e.avif";